module.exports = __webpack_public_path__ + "img/guide-suunto-1-web.b038835c.jpg";